import { API } from '@/src/api/api'
import { useProductAnalytics } from '@/src/api/data/analytics'
import { queryClient } from '@/src/api/queryClient'
import { queryKeys } from '@/src/api/queryKeys'
import type { CreateIsoMeasureDto } from '@/src/api/types/generated-types'
import { useMutation } from '@tanstack/react-query'

export const useCreateMeasureFromInsight = () => {
  const { reportEvent } = useProductAnalytics()

  return useMutation({
    mutationFn: ({ insightId, dto }: { insightId: number; dto: CreateIsoMeasureDto }) =>
      API.savingsFlow.createMeasureFromInsight(insightId, dto),
    onSuccess: (_, variables) => {
      reportEvent('measure_created', { insightId: variables.insightId, source: 'insight' })
      queryClient.invalidateQueries({ queryKey: queryKeys.iso.measures.manyByCompanyId.toKey() })
      queryClient.invalidateQueries({ queryKey: queryKeys.iso.insightInbox.toKey() })
    },
  })
}
